import React from "react";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import logo from "../assets/Images/WPM-Logo.png";
import { logout, getUserName, getRole } from "../services/authenticationService";
import About from './About';
import { Navbar, Nav } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import '../assets/styles/Header.scss';

const Header: React.FC = () => {
	const [modalShow, setModalShow] = useState(false);
	const location = useLocation();
	const publicLinks = ['/login', '/signup', '/forgot_password', '/error', '/about', '/reset_password'];

	return (
		<div id="header-component">
			<Navbar className="header border-bottom" collapseOnSelect expand="lg" bg="light" >
				<Navbar.Brand >
					<img className="wpm-logo ps-2 pb-2" id="logo" src={logo} alt="" />
				</Navbar.Brand>
				{publicLinks.indexOf(location.pathname) !== -1 &&
					<Nav.Link
						className={`header-contex pointer mb-2
		                ${modalShow ? 'link-primary text-decoration-none' : ''}`}
						id="about" data-testid="about-link" href='#' onClick={() => setModalShow(true)}
					> About
					</Nav.Link>
				}
				{publicLinks.indexOf(location.pathname) === -1 &&
					<>
						<Navbar.Toggle aria-controls="responsive-navbar-nav" />
						<Navbar.Collapse id="responsive-navbar-nav">
							<Nav className="me-auto" activeKey={'/#' + location.pathname}>
								{publicLinks.indexOf(location.pathname) === -1 &&
									<>
										<Nav.Link
											className='header-contex pointer'
											id="Pole-analysis" href='/#/viewer_dashboard'
										> Pole Information </Nav.Link>
									</>
								}
								{getRole() === 'Admin' &&
									<Nav.Link
										className='header-contex pointer'
										id="admin-dash" href='/#/user_managment'
									> Users </Nav.Link>
								}
								<Nav.Link
									className={`header-contex pointer mb-2
							${modalShow ? 'link-primary text-decoration-none' : ''}`}
									id="about" href='#' onClick={() => setModalShow(true)}
								> About
								</Nav.Link>
							</Nav>
							{publicLinks.indexOf(location.pathname) === -1 &&
								<Nav>
									<span className='desktop-hide header-contex mt-3 mb-2 fw-bold' id="label">
										<Icon.PersonFill className="icon fw-bold me-2 mb-1" id="person-icon" />
										{getUserName()}
									</span>
									<a className='desktop-hide header-contex pointer text-decoration-none mt-3'
										id="logout-1" onClick={logout}>
										<Icon.BoxArrowLeft className="icon fw-bold me-2 mb-1" id="signout-icon" />
										Logout
									</a>
									<span className='header-contex mobile-hide' id="label">
										Hello {getUserName().split(' ')[0]}
									</span>
									<a className='mobile-hide header-contex pointer link-primary'
										id="logout" onClick={logout}>
										Logout
									</a>
								</Nav>
							}
						</Navbar.Collapse>
					</>
				}
			</Navbar>
			<About
				show={modalShow}
				onHide={() => setModalShow(false)}
			/>
		</div>
	);
};

export default Header;